import { Badge } from '@edgebox/react-components';
import React from 'react';

type Props = {
  sys: { isPublished?: boolean | null; createdAt?: string | null };
};

export function EntryPublishedBadge({ sys }: Props) {
  return sys.isPublished ? (
    <Badge bg="success">Published</Badge>
  ) : sys.createdAt ? (
    <Badge bg="info">Changed</Badge>
  ) : (
    <Badge bg="warning">Draft</Badge>
  );
}
